import { Component } from '@angular/core';

@Component({
  selector: 'app-experiment-create-details',
  templateUrl: './experiment-create-details.component.html',
  styleUrl: './experiment-create-details.component.css'
})
export class ExperimentCreateDetailsComponent {
  public experimentName = '';
  public experimentDescription = '';
}
